import React from "react";
import { Button, Container, Row, Col } from "reactstrap";
import DisplayLottie from "../components/DisplayLottie";

const Hero = ({ data }) => {
  return (
    <main>
      <div className="position-relative">
        <section className="section section-lg section-shaped ">
          <div className="shape shape-style-1 bg-gradient-info">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-lg-md d-flex">
            <div className="col px-0">
              <Row>
                <Col lg="6">
                  <br />
                  <h1 className="display-3 text-white">{data.title + " "}</h1>
                  <p className="lead text-white">{data.description}</p>

                  {data.resumeLink && (
                    <div className="btn-wrapper my-4">
                      {/* <Button
                        className="btn-white btn-icon mb-3 mb-sm-0 ml-1"
                        color="default"
                        href={data.resumeLink}
                      >
                        <span className="btn-inner--icon mr-1">
                          <i className="fa fa-file" />
                        </span>
                        <span className="btn-inner--text">See My Resume</span>
                      </Button> */}
                    </div>
                  )}
                </Col>
                <Col lg="6">
                  <DisplayLottie animationPath={data.lottieAnimationFile} />
                </Col>
              </Row>
            </div>
          </Container>
          {/* SVG separator */}
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
        {/* 1st Hero Variation */}
      </div>
    </main>
  );
};

export default Hero;
